import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Grid, IconButton } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import MyContext from "../../../../contexts/MyContext";
import { AddReceiptNew } from "./AddReceiptNew";

export const AddFoodReceiptDialogNew = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);

  const handleSave = (receipt, totalCost) => {
    myContext.changeFoodReceipt(receipt);
    myContext.changeFoodTotalCost(totalCost);
    props.onClose();
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <Dialog fullScreen open={props.open} onClose={props.onClose}>
          <MuiDialogTitle>
            <IconButton aria-label="close" style={{ float: "right" }} onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </MuiDialogTitle>
          <Grid container justifyContent="center" className="container custom">
            <Grid item>
              <strong>{t("add_receipt_for_expenses")}</strong>
              <p className="margin bottom-0">{t("add_all_receipts_for_food")}</p>
              <p>
                <small>{t("max_25MB_per_file")}</small>
              </p>
              <AddReceiptNew totalCost={context.foodTotalCost} onSave={handleSave} receipt={context.foodReceipt} {...props} />
            </Grid>
          </Grid>
        </Dialog>
      )}
    </MyContext.Consumer>
  );
};
